import { BaseSidebarObject } from '@y42/gojs';

export class AttentionNode extends BaseSidebarObject {
  constructor(public key = '', public category = '', public location = '0 0', public ATTACHED_TO = '') {
    super();
  }
}
